import React, { useState, useEffect } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { useFragment } from 'react-relay';
import { graphql } from 'babel-plugin-relay/macro';

import usePageTitle from '../../hooks/usePageTitle';

import TypoContainer from '../../uikit/TypoContainer';
import SpeakerForm from '../../components/Forms/SpeakerForm';

import type { BecomeSpeakerQuery$key } from './__generated__/BecomeSpeakerQuery.graphql';

import { ReactComponent as DudeRedSpeaking } from '../../assets/img/dude/dude-red-speaking.svg';

import './BecomeSpeaker.sass';

interface Props {
	query: BecomeSpeakerQuery$key | null;
}

function BecomeSpeaker(props: Props) {
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	const data: any = useFragment(
		graphql`
			fragment BecomeSpeakerQuery on HomePublishedContent {
				_children {
					items {
						... on FormPagePublishedContent {
							title
							metaTitle
							formType
							content
							nameLabel
							surnameLabel
							emailLabel
							companyNameLabel
							registrationCityLabel
							privacyPolicyLabelText
							speakerTitleLabel
							speakerBioLabel
							speakerSocialMediaLabel
							speakerPhotoLabel
							speakerTalkTitle
							speakerTalkNameLabel
							speakerFormatLabel
							speakerFormatTooltip
							speakerLanguageLabel
							speakerTrackLabel
							speakerTrackTooltip
							speakerAudienceLevelLabel
							speakerTalkKeyPointsLabel
							speakerTalkDescriptionLabel
							speakerCoSpeakerLabel
							speakerCodeOfConductAndSpeakerContractAgreementLabel
							speakerAddTalkButtonLabel
							submitButtonLabel
							cityPlaceholder
							speakerBioPlaceholder
							speakerFacebookLinkPlaceholder
							speakerLinkedinLinkPlaceholder
							speakerTwitterLinkPlaceholder
							speakerPhotoPlaceholder
							speakerPhotoBottomDescription
							speakerFormatPlaceholder
							speakerLanguagePlaceholder
							speakerTrackPlaceholder
							speakerAudienceLevelPlaceholder
							speakerTalkKeyPointsPlaceholder
							speakerTalkDescriptionPlaceholder
							speakerFormatValues
							speakerLanguageValues
							speakerTrackValues
							speakerAudienceLevelValues
							speakerBioTooltip
							speakerTalkNameTooltip
							speakerTalkDescriptionTooltip
							speakerLanguageTooltip
						}
					}
				}
			}
		`,
		props.query
	);
	const [fetchedData, setFetchedData] = useState<{
		title: string;
		content: string;
		metaTitle: string;
		formType: string;
		nameLabel: string;
		surnameLabel: string;
		emailLabel: string;
		companyNameLabel: string;
		registrationCityLabel: string;
		privacyPolicyLabelText: string;
		speakerTitleLabel: string;
		speakerBioLabel: string;
		speakerSocialMediaLabel: string;
		speakerPhotoLabel: string;
		speakerTalkTitle: string;
		speakerTalkNameLabel: string;
		speakerFormatLabel: string;
		speakerFormatTooltip: string;
		speakerLanguageLabel: string;
		speakerTrackLabel: string;
		speakerTrackTooltip: string;
		speakerAudienceLevelLabel: string;
		speakerTalkKeyPointsLabel: string;
		speakerTalkDescriptionLabel: string;
		speakerCoSpeakerLabel: string;
		speakerCodeOfConductAndSpeakerContractAgreementLabel: string;
		speakerAddTalkButtonLabel: string;
		submitButtonLabel: string;
		cityPlaceholder: string;
		speakerBioPlaceholder: string;
		speakerFacebookLinkPlaceholder: string;
		speakerLinkedinLinkPlaceholder: string;
		speakerTwitterLinkPlaceholder: string;
		speakerPhotoPlaceholder: string;
		speakerPhotoBottomDescription: string;
		speakerFormatPlaceholder: string;
		speakerLanguagePlaceholder: string;
		speakerTrackPlaceholder: string;
		speakerAudienceLevelPlaceholder: string;
		speakerTalkKeyPointsPlaceholder: string;
		speakerTalkDescriptionPlaceholder: string;
		speakerBioTooltip: string;
		speakerTalkNameTooltip: string;
		speakerTalkDescriptionTooltip: string;
		speakerLanguageTooltip: string;
		speakerFormatValues: [];
		speakerLanguageValues: [];
		speakerTrackValues: [];
		speakerAudienceLevelValues: [];
	}>();

	useEffect(() => {
		data._children.items.map(
			(item: {
				metaTitle: string;
				title: string;
				content: string;
				formType: string;
				nameLabel: string;
				surnameLabel: string;
				emailLabel: string;
				companyNameLabel: string;
				registrationCityLabel: string;
				privacyPolicyLabelText: string;
				speakerTitleLabel: string;
				speakerBioLabel: string;
				speakerSocialMediaLabel: string;
				speakerPhotoLabel: string;
				speakerTalkTitle: string;
				speakerTalkNameLabel: string;
				speakerFormatLabel: string;
				speakerFormatTooltip: string;
				speakerLanguageLabel: string;
				speakerTrackLabel: string;
				speakerTrackTooltip: string;
				speakerAudienceLevelLabel: string;
				speakerTalkKeyPointsLabel: string;
				speakerTalkDescriptionLabel: string;
				speakerCoSpeakerLabel: string;
				speakerCodeOfConductAndSpeakerContractAgreementLabel: string;
				speakerAddTalkButtonLabel: string;
				submitButtonLabel: string;
				cityPlaceholder: string;
				speakerBioPlaceholder: string;
				speakerFacebookLinkPlaceholder: string;
				speakerLinkedinLinkPlaceholder: string;
				speakerTwitterLinkPlaceholder: string;
				speakerPhotoPlaceholder: string;
				speakerPhotoBottomDescription: string;
				speakerFormatPlaceholder: string;
				speakerLanguagePlaceholder: string;
				speakerTrackPlaceholder: string;
				speakerAudienceLevelPlaceholder: string;
				speakerTalkKeyPointsPlaceholder: string;
				speakerTalkDescriptionPlaceholder: string;
				speakerBioTooltip: string;
				speakerTalkNameTooltip: string;
				speakerTalkDescriptionTooltip: string;
				speakerLanguageTooltip: string;
				speakerFormatValues: [];
				speakerLanguageValues: [];
				speakerTrackValues: [];
				speakerAudienceLevelValues: [];
			}) => {
				if (
					item &&
					Object.keys(item).length !== 0 &&
					item.formType === 'speaker-registration'
				) {
					setFetchedData(item);
				}
			}
		);
	}, [data]);
	usePageTitle(fetchedData?.metaTitle);
	return (
		<div className="become-speaker-page">
			<Container>
				<Row className="sticky-layout">
					{fetchedData && (
						<>
							<Col xs={12} lg={5} className="sticky-layout__sidebar">
								<Row className="sticky-layout__sidebar-content">
									<Col
										xs={12}
										md={6}
										lg={12}
										className="sticky-layout__heading"
									>
										<h1 className="uikit-heading-hg">{fetchedData.title}</h1>
									</Col>
									<Col
										xs={12}
										md={6}
										lg={12}
										className="sticky-layout__animation become-speaker-page__animation"
									>
										<DudeRedSpeaking />
									</Col>
								</Row>
							</Col>
							<Col
								xs={12}
								lg={{ offset: 1, span: 6 }}
								className="sticky-layout__content"
							>
								<TypoContainer markup={fetchedData.content} />
								<SpeakerForm {...fetchedData} />
							</Col>
						</>
					)}
				</Row>
			</Container>
		</div>
	);
}

export default BecomeSpeaker;
